import React from "react";

import { colors } from "@zapalacorp/tokens";

interface Props {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}

const OutlinedSend = ({
  className,
  color = colors.gray400,
  height = "20",
  width = "20",
}: Props) => {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.50831 18.125C3.57498 18.125 2.98331 17.8083 2.60831 17.4333C1.87498 16.7 1.35831 15.1416 3.00831 11.8333L3.73331 10.3916C3.82498 10.2 3.82498 9.79996 3.73331 9.60829L3.00831 8.16663C1.34998 4.85829 1.87498 3.29162 2.60831 2.56662C3.33331 1.83329 4.89998 1.30829 8.19998 2.96662L15.3333 6.53329C17.1083 7.41662 18.0833 8.64996 18.0833 9.99996C18.0833 11.35 17.1083 12.5833 15.3416 13.4666L8.20831 17.0333C6.59164 17.8416 5.39164 18.125 4.50831 18.125ZM4.50831 3.12496C4.05831 3.12496 3.70831 3.23329 3.49164 3.44996C2.88331 4.04996 3.12498 5.60829 4.12498 7.59996L4.84998 9.04996C5.11664 9.59162 5.11664 10.4083 4.84998 10.95L4.12498 12.3916C3.12498 14.3916 2.88331 15.9416 3.49164 16.5416C4.09164 17.15 5.64998 16.9083 7.64998 15.9083L14.7833 12.3416C16.0916 11.6916 16.8333 10.8333 16.8333 9.99162C16.8333 9.14996 16.0833 8.29162 14.775 7.64162L7.64164 4.08329C6.37498 3.44996 5.28331 3.12496 4.50831 3.12496Z"
        fill={color}
      />
      <path
        d="M9.03331 10.625H4.53331C4.19164 10.625 3.90831 10.3416 3.90831 9.99996C3.90831 9.65829 4.19164 9.37496 4.53331 9.37496H9.03331C9.37498 9.37496 9.65831 9.65829 9.65831 9.99996C9.65831 10.3416 9.37498 10.625 9.03331 10.625Z"
        fill={color}
      />
    </svg>
  );
};

export default OutlinedSend;
